<template>
	<div>
		<v-alert :color="color.color" class="mt-2 mb-0 pa-2 rounded-lg" :class="color.text">
			<div class="d-flex">
				<v-icon :color="type == 'failed' ? 'red' : 'green'">{{ status | toIconTransaction }}</v-icon>
				<div class="my-auto pl-2 font-size-13">{{ status | toStatusTransaction }}</div>
			</div>
		</v-alert>
	</div>
</template>

<script>
export default {
	props:{
		status: String
	},
	computed: {
		type () {
			return this.$options.filters.toTypeTransaction(this.status);
		},
		color() {
			switch (this.type) {
				case 'failed':
				return {
					color: 'pink lighten-5',
					text: 'red--text'
				}

				default:
				return {
					color: 'green lighten-5',
					text: 'green--text'
				}
			}
		}
	},
	created() {
	}
};
</script>